import React from "react";
import { PopUp, Pagination, PageNavigation } from "../../components";
import { TagsSettingsLogic } from "./TagsSettingsLogic";
import { PredefinedTextForm } from "../../components/PredefinedText/PredefinedTextForm";
import { PredefinedTextItem } from "../../components/PredefinedText/PredefinedTextItem";
import { ComplementSettings } from "../../components/ComplementSettings/ComplementSettings";
import { useAuth } from "../../contexts/AuthContext";

export const TagsSettings = () => {
  const { checkLicense } = useAuth();
  const {
    paramsState,
    error,
    tags,
    tab,
    pagination,
    togglePopup,
    getTags,
    setTab,
    texts,
    removePredefinedText,
    savePredefinedText,
    methods,
    handleExpand,
    showTextForm,
  } = TagsSettingsLogic();

  return (
    <div>
      <h1>
        {tab === "TAG"
          ? "Nastavení štítků"
          : tab === "TEXT"
          ? "Předdefinované texty"
          : "Nastavení referenčních mezí laboratórních výsledků"}
      </h1>
      <PageNavigation className="sub-page-navigation present">
        <div>
          <a
            className={tab === "TAG" && "active"}
            id="pharmaPlanVerification"
            onClick={() => setTab("TAG")}
            style={{ paddingLeft: 12, paddingRight: 12 }}
          >
            Štítky
          </a>
          <a
            className={tab === "TEXT" && "active"}
            id="pharmaPlanVerification"
            onClick={() => setTab("TEXT")}
            style={{ paddingLeft: 12, paddingRight: 12 }}
          >
            Předdefinované texty
          </a>
          {checkLicense("complement") && (
            <a
              className={tab === "COMPLEMENT" && "active"}
              id="complementSettings"
              onClick={() => setTab("COMPLEMENT")}
              style={{ paddingLeft: 12, paddingRight: 12 }}
            >
              Komplement
            </a>
          )}
        </div>
      </PageNavigation>

      {tab === "TAG" && (
        <div className="max-w-1524">
          <div className="myContent">
            <div className="grid-row wrap tag">
              {error.error && (
                <PopUp toggle={togglePopup} message={error.message} />
              )}
              {tags.loading ? <h2>Načítání štítků...</h2> : tags.tags}
            </div>
            <div className="grid-row">
              <div className="col-12">
                <Pagination
                  onSubmit={getTags}
                  pagination={pagination ? pagination : {}}
                  paramsState={paramsState}
                  limit={60}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {tab === "TEXT" && (
        <div className="max-w-1524">
          <div className="myContent">
            <button
              className="button mb-5"
              onClick={() => handleExpand(undefined)}
            >
              Nový text
            </button>
            {showTextForm && (
              <PredefinedTextForm
                savePredefinedText={savePredefinedText}
                methods={methods}
              />
            )}
            {texts.map((item) => (
              <PredefinedTextItem
                text={item}
                handleRemove={removePredefinedText}
                handleExpand={handleExpand}
              />
            ))}
          </div>
        </div>
      )}
      {tab === "COMPLEMENT" && checkLicense("complement") && (
        <ComplementSettings />
      )}
    </div>
  );
};
